import { useParams, Link, useNavigate } from "react-router-dom";
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from "../../utils/authFetch";

const ExcluirUsuario = () => {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
            
    const { id } = useParams(); // Pegando o ID do usuário da URL    

    const handleDelete = async () => {
        const confirmDelete = window.confirm("Tem certeza que deseja excluir sua conta? Essa ação é irreversível!");

        if (!confirmDelete) return;

        try {
            const response = await authFetch(`user/${id}`, {
                method: "DELETE",                
            });

            if (!response.ok) throw new Error("Erro ao excluir a conta!");

            showNotification("success", "Conta excluída com sucesso!");
                        
            setTimeout(() => navigate("/Usuarios"), 1000);
        } catch (error) {
            console.error("Erro:", error);
            showNotification("danger", "Erro ao excluir a conta!");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Excluir Usuário</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <p>Essa ação é irreversível. Tem certeza que deseja excluir sua conta?</p>
                            <div className="card-footer" style={{ paddingLeft: "0" }}>
                                <Link to="/Usuarios" className="btn btn-info btn-sm">
                                    Voltar
                                </Link>
                                <button className="btn btn-danger btn-sm mx-1" onClick={handleDelete}>
                                    Excluir Conta
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ExcluirUsuario;